$shm_hotkey $mol_view
	scope \default
	root null
	auto /
		<= listeners null
	sub <= layers /$mol_view
	Model $shm_hotkey_model
		scope <= scope
	Style $mol_view
		dom_name \style
		sub / <= rules \
	Mark* $shm_hotkey_mark
		label <= mark_label* \
		anchor <= anchor_name* \
	Editor $shm_hotkey_editor
		anchor <= editor_anchor \
		status <= status? \
		activation_label <= activation_label \
		message <= editor_message \
		remove_enabled <= remove_enabled false
		remove? <=> remove? null
		configure? <=> configure? null
